import React from 'react';
import { createPortal } from 'react-dom';
import './Ticker.css';

const Ticker = () => {
  const message = "If you are having issues booking your appointment, completing your questionnaire or any questions, please contact at ";
  const phoneNumber = "512-957-0001";
  
  const tickerContent = (
    <div 
      className="ticker-container" 
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100vw',
        backgroundColor: '#fc8c02',
        color: '#ffffff',
        padding: '12px 0',
        overflow: 'hidden',
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        minHeight: '44px',
        margin: 0
      }}
    >
      <div className="ticker-content">
        <span className="ticker-text">
          {message}
          <a href={`tel:${phoneNumber.replace(/-/g, '')}`} style={{ color: '#ffffff', textDecoration: 'underline' }}>{phoneNumber}</a>
        </span>
        <span className="ticker-text" aria-hidden="true">
          {message}
          <a href={`tel:${phoneNumber.replace(/-/g, '')}`} style={{ color: '#ffffff', textDecoration: 'underline' }}>{phoneNumber}</a>
        </span>
      </div>
    </div>
  );
  
  // Render directly to document.body to ensure fixed positioning works
  if (typeof document !== 'undefined' && document.body) {
    return createPortal(tickerContent, document.body);
  }
  
  // Fallback if document.body is not available
  return tickerContent;
};

export default Ticker;

